<div class="row mrgn-bttm-lg">
    <div class="col-md-12">
        <div>
        <h3 class="text-center">
            {{ 'components.confirmTermsDialog.apiDownload.terms.title_line1' | translate }}<br>
            {{ 'components.confirmTermsDialog.apiDownload.terms.title_line2' | translate }}
        </h3>
        <h4>
            <strong>{{ 'components.confirmTermsDialog.apiDownload.terms.part1' | translate }}</strong>
        </h4>
        <p>{{ 'components.confirmTermsDialog.apiDownload.terms.part1_description1' | translate }}</p>
        <p>{{ 'components.confirmTermsDialog.apiDownload.terms.part1_description2' | translate }}</p>
        <p>{{ 'components.confirmTermsDialog.apiDownload.terms.part1_description3' | translate }}</p>
        <h4>
            <strong>{{ 'components.confirmTermsDialog.apiDownload.terms.part2' | translate }}</strong>
        </h4>
        <p>{{ 'components.confirmTermsDialog.apiDownload.terms.part2_description1' | translate }}</p>
        <ol type="a">
          <li [innerHtml]="termsAndApendix.terms.part2_description1_item_a"></li>
          <li [innerHtml]="termsAndApendix.terms.part2_description1_item_b"></li>
          <li [innerHtml]="termsAndApendix.terms.part2_description1_item_c"></li>
          <li [innerHtml]="termsAndApendix.terms.part2_description1_item_d"></li>
        </ol>

        <h4>
            <strong>{{ 'components.confirmTermsDialog.apiDownload.terms.part3' | translate }}</strong>
        </h4>
        <h5>
            <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part3_description1_title' | translate }}</u>
        </h5>
        <p>{{ 'components.confirmTermsDialog.apiDownload.terms.part3_description1' | translate }}</p>
        <h5>
            <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part3_description2_title' | translate }}</u>
        </h5>
        <p>{{ 'components.confirmTermsDialog.apiDownload.terms.part3_description2' | translate }}</p>
        <h5>
            <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part3_description3_title' | translate }}</u>
        </h5>
        <p>{{ 'components.confirmTermsDialog.apiDownload.terms.part3_description3' | translate }}</p>
        
        <h4>
            <strong>{{ 'components.confirmTermsDialog.apiDownload.terms.part4' | translate }}</strong>
        </h4>
        <p>{{ 'components.confirmTermsDialog.apiDownload.terms.part4_description1' | translate }}</p>
        <h5>
            <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part4_description1_title' | translate }}</u>
        </h5>
        <ol type="I">
            <li [innerHtml]="termsAndApendix.terms.part4_description1_item_I"></li>
            <li [innerHtml]="termsAndApendix.terms.part4_description1_item_II"></li>
        </ol>

        <h4>
            <strong>{{ 'components.confirmTermsDialog.apiDownload.terms.part5' | translate }}</strong>
        </h4>
        <ol type="I">
            <li [innerHtml]="termsAndApendix.terms.part5_description1_item_1"></li>
        </ol>

        <h4>
            <strong>{{ 'components.confirmTermsDialog.apiDownload.terms.part6' | translate }}</strong>
        </h4>
        <h5>
            <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part6_description1_title' | translate }}</u>
        </h5>
        <ol type="I">
          <li [innerHtml]="termsAndApendix.terms.part6_description1_item_I"></li>
          <li [innerHtml]="termsAndApendix.terms.part6_description1_item_II"></li>
          <li [innerHtml]="termsAndApendix.terms.part6_description1_item_III"></li>
        </ol>

        <h4>
            <strong>{{ 'components.confirmTermsDialog.apiDownload.terms.part7' | translate }}</strong>
        </h4>
        <ol type="I">
            <li [innerHtml]="termsAndApendix.terms.part7_description1_item_I"></li>
        </ol>
        
        <h4>
            <strong>{{ 'components.confirmTermsDialog.apiDownload.terms.part8' | translate }}</strong>
        </h4>
        <h5>
            <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part8_description1_item_I_title' | translate }}</u>
        </h5>
        <ol type="I">
            <li [innerHtml]="termsAndApendix.terms.part8_description1_item_I"></li>
            <ol type="a">
                <li [innerHtml]="termsAndApendix.terms.part8_description1_item_I_item_a"></li>
                <ol type="i">
                    <li [innerHtml]="termsAndApendix.terms.part8_description1_item_I_item_a_item_i"></li>
                    <li [innerHtml]="termsAndApendix.terms.part8_description1_item_I_item_a_item_ii"></li>
                    <li [innerHtml]="termsAndApendix.terms.part8_description1_item_I_item_a_item_iii"></li>
                    <li [innerHtml]="termsAndApendix.terms.part8_description1_item_I_item_a_item_iv"></li>
                    <li [innerHtml]="termsAndApendix.terms.part8_description1_item_I_item_a_item_v"></li>
                  </ol>
                <li [innerHtml]="termsAndApendix.terms.part8_description1_item_I_item_b"></li>
            </ol>
            <li [innerHtml]="termsAndApendix.terms.part8_description1_item_II"></li>
            <li [innerHtml]="termsAndApendix.terms.part8_description1_item_III"></li>
            <li [innerHtml]="termsAndApendix.terms.part8_description1_item_IV"></li>
            <li>
                <p [innerHtml]="termsAndApendix.terms.part8_description1_item_V_part1"></p>
                <p [innerHtml]="termsAndApendix.terms.part8_description1_item_V_part2"></p>
                <p [innerHtml]="termsAndApendix.terms.part8_description1_item_V_part3"></p>
            </li>
            <li [innerHtml]="termsAndApendix.terms.part8_description1_item_VI"></li>
            <li [innerHtml]="termsAndApendix.terms.part8_description1_item_VII"></li>
            <h5>
                <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part8_description1_item_VIII_title' | translate }}</u>
            </h5>
            <li [innerHtml]="termsAndApendix.terms.part8_description1_item_VIII"></li>
        </ol>
        <h5>
            <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part8_description1_item_dev_terms_title' | translate }}</u>
        </h5>
        <p [innerHtml]="termsAndApendix.terms.part8_description1_item_dev_terms"></p>

        <h4>
            <strong>{{ 'components.confirmTermsDialog.apiDownload.terms.part9' | translate }}</strong>
        </h4>
        <h5>
            <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part9_description1_item_I_title' | translate }}</u>
        </h5>
        <ol type="I">
            <li [innerHtml]="termsAndApendix.terms.part9_description1_item_I"></li>
            <li [innerHtml]="termsAndApendix.terms.part9_description1_item_II"></li>
            <li [innerHtml]="termsAndApendix.terms.part9_description1_item_III"></li>
        </ol>

        <h4>
            <strong>{{ 'components.confirmTermsDialog.apiDownload.terms.part10' | translate }}</strong>
        </h4>
        <ol type="I">
            <h5>
                <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part10_description1_item_I_title' | translate }}</u>
            </h5>
            <li [innerHtml]="termsAndApendix.terms.part10_description1_item_I"></li>
            <h5>
                <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part10_description1_item_II_title' | translate }}</u>
            </h5>
            <li [innerHtml]="termsAndApendix.terms.part10_description1_item_II"></li>
            <h5>
                <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part10_description1_item_III_title' | translate }}</u>
            </h5>
            <li [innerHtml]="termsAndApendix.terms.part10_description1_item_III"></li>
            <h5>
                <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part10_description1_item_IV_title' | translate }}</u>
            </h5>
            <li [innerHtml]="termsAndApendix.terms.part10_description1_item_IV"></li>
            <h5>
                <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part10_description1_item_V_title' | translate }}</u>
            </h5>
            <li [innerHtml]="termsAndApendix.terms.part10_description1_item_V"></li>        
            <h5>
                <u>{{ 'components.confirmTermsDialog.apiDownload.terms.part10_description1_item_VI_title' | translate }}</u>
            </h5>
            <li [innerHtml]="termsAndApendix.terms.part10_description1_item_VI"></li>        
        </ol>
        </div>
    </div>
</div>
<div class="row mrgn-bttm-xl mrgn-tp-md">
    <div class="col-md-12">
        <div>
            <h3 class="text-center">
                {{ 'components.confirmTermsDialog.apiDownload.apendix.title_line1' | translate }}<br>
                {{ 'components.confirmTermsDialog.apiDownload.apendix.title_line2' | translate }}
            </h3>
            <h4>
                <strong>{{ 'components.confirmTermsDialog.apiDownload.apendix.part1' | translate }}</strong>
            </h4>
            <p>{{ 'components.confirmTermsDialog.apiDownload.apendix.part1_description1' | translate }}</p>
            <p>{{ 'components.confirmTermsDialog.apiDownload.apendix.part1_description2' | translate }}</p>
            
            <h4>
                <strong>{{ 'components.confirmTermsDialog.apiDownload.apendix.part2' | translate }}</strong>
            </h4>
            <ol type="a">
                <li [innerHtml]="termsAndApendix.apendix.part2_description1_item_a"></li>
                <li [innerHtml]="termsAndApendix.apendix.part2_description1_item_b"></li>
                <li [innerHtml]="termsAndApendix.apendix.part2_description1_item_c"></li>
                <li [innerHtml]="termsAndApendix.apendix.part2_description1_item_d"></li>
                <li [innerHtml]="termsAndApendix.apendix.part2_description1_item_e"></li>
            </ol>

            <h4>
                <strong>{{ 'components.confirmTermsDialog.apiDownload.apendix.part3' | translate }}</strong>
            </h4>
            <p>{{ 'components.confirmTermsDialog.apiDownload.apendix.part3_description1' | translate }}</p>
            <ol type="I">
                <h5>
                    <u>{{ 'components.confirmTermsDialog.apiDownload.apendix.part3_description1_item_I_title' | translate }}</u>
                </h5>
                <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_I"></li>
                <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_II"></li>
                <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_III"></li>
                <ol type="a">
                    <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_III_item_a"></li>
                    <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_III_item_b"></li>
                </ol>
                <h5>
                    <u>{{ 'components.confirmTermsDialog.apiDownload.apendix.part3_description1_item_IV_title' | translate }}</u>
                </h5>
                <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_IV"></li>
                <ol type="a">
                    <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_IV_item_a"></li>
                    <ol type="i">
                        <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_IV_item_a_item_i"></li>
                        <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_IV_item_a_item_ii"></li>
                        <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_IV_item_a_item_iii"></li>
                        <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_IV_item_a_item_iv"></li>
                        <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_IV_item_a_item_v"></li>
                    </ol>
                    <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_IV_item_b"></li>
                    <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_IV_item_c"></li>
                </ol>
                <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_V"></li>
                <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_VI"></li>
                <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_VII"></li>
                <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_VIII"></li>
                <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_IX"></li>
                <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_X"></li>
                <h5>
                    <u>{{ 'components.confirmTermsDialog.apiDownload.apendix.part3_description1_item_XI_title' | translate }}</u>
                </h5>
                <li [innerHtml]="termsAndApendix.apendix.part3_description1_item_XI"></li>
            </ol>
        </div>  
    </div>
</div>